import { EventName } from "module/analytics/types"

import { ButtonProps, HStack, Skeleton, Text, VStack, useColorModeValue } from "@chakra-ui/react"
import { TxButton } from "component/TxButton"
import { useCallback } from "react"
import { DelegateApproval } from "sdk-react/limitOrder/useDelegateApproval"

import { CreateOrder } from "../../hook/useCreateOrder"
import { LimitOrderDeadlineSetting } from "./LimitOrderDeadlineSetting"

interface TradingSubmitButtonLimitOrderProps extends ButtonProps {}

export function TradingSubmitButtonLimitOrder({ isDisabled, ...buttonProps }: TradingSubmitButtonLimitOrderProps) {
    const { handleSubmit, orderType } = CreateOrder.useContainer()

    return (
        <TxButton
            colorScheme="perpetual"
            variant="solid"
            size="sm"
            isDisabled={isDisabled}
            onClick={handleSubmit}
            trackingProps={{
                eventName: EventName.LIMIT_ORDER_SUBMIT_CLICK,
                payload: { orderType },
            }}
            {...buttonProps}
        >
            Confirm Limit Order
        </TxButton>
    )
}

interface ApproveLimitOrderButtonProps extends ButtonProps {}
export function ApproveLimitOrderButton({ ...buttonProps }: ApproveLimitOrderButtonProps) {
    const { approve, isApproved } = DelegateApproval.useContainer()

    const handleClick = useCallback(() => {
        if (!isApproved) {
            return approve()
        } else {
            // revoke()
        }
    }, [approve, isApproved])

    return (
        <TxButton
            colorScheme="perpetual"
            variant="solid"
            size="sm"
            onClick={handleClick}
            trackingProps={{ eventName: EventName.LIMIT_ORDER_APPROVE_CLICK }}
            {...buttonProps}
        >
            Approve Limit Order
        </TxButton>
    )
}

interface TradingSubmitLimitOrderProps {
    isDisabled: boolean
    size?: string
}

export function TradingSubmitLimitOrder({ isDisabled, size }: TradingSubmitLimitOrderProps) {
    const { isChecking, isApproved } = DelegateApproval.useContainer()
    const subText = useColorModeValue("gray.500", "gray.400")

    return (
        <HStack>
            {isApproved ? (
                <HStack w="100%">
                    <TradingSubmitButtonLimitOrder size={"sm"} isDisabled={isDisabled} />
                    <LimitOrderDeadlineSetting />
                </HStack>
            ) : (
                <Skeleton isLoaded={!isChecking}>
                    <VStack>
                        <ApproveLimitOrderButton size={"sm"} />
                        <Text fontSize="xs" color={subText}>
                            You have to approve before placing a limit order. One-time only.
                        </Text>
                    </VStack>
                </Skeleton>
            )}
        </HStack>
    )
}
